export interface UIPackageRouteParams {
  namespace: string;
  repo: string;
  filePath: string;
}
